// extracted by mini-css-extract-plugin
module.exports = {"internalTransfersContainer":"internal-transfers_internalTransfersContainer__3GWdt"};